import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from '@progress/kendo-react-layout';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { BagelLapsPatientWorkoutDetail } from '../../../store/types/BagelLapsPatientWorkoutDetail';
import api from '../../../utils/api';
import '../PatientPage.css';

interface BagelLapsWorkoutDetailProps {
  ptCd: string;
  id: number;
}


const BagelLapsWorkoutDetailComponent: React.FC<BagelLapsWorkoutDetailProps> = (
    props
    ) => {
  const user = useSelector((state: RootState) => state.user.user);
  const [bagelLapsWorkoutDetail, setBagelLapsWorkoutDetail] =
     useState<BagelLapsPatientWorkoutDetail | null>(null);

  useEffect(() => {
    const fetchDetail = async () => {
      if (user?.hospital?.hspCd) {
        try {
          const response = await api.getBagelLapsWorkoutDetail(
            props.ptCd, 
            props.id, 
            user.hospital.hspCd
            );
            setBagelLapsWorkoutDetail(response.data);
            console.log(response.data)
        } catch (error) {
          console.error('BagelLaps 운동 상세 불러오기 실패:', error);
        }
      }
    };

    fetchDetail();
  }, [props.id]);
  return (
    <div className="recordContainer">
      <Card>
        <CardHeader>
          <CardTitle>BagelLaps 운동 상세 정보</CardTitle>
        </CardHeader>
  
        <CardBody>
          <p><strong>환자 코드:</strong> {bagelLapsWorkoutDetail?.ptCd}</p>
          <p><strong>운동 날짜:</strong> {bagelLapsWorkoutDetail?.createdAt}</p>
          <p>
            <strong>TV 단계 / 점수:</strong>{' '}
            {bagelLapsWorkoutDetail?.tvStage}단계 / {bagelLapsWorkoutDetail?.tvScore}점
          </p>
          <p><strong>기계 난이도:</strong> {bagelLapsWorkoutDetail?.machineLvl}</p>
  
          <PanelBar>
            <PanelBarItem title="운동 횟수">
              <p><strong>기상 후 STS:</strong> {bagelLapsWorkoutDetail?.stsMornCount ?? '-'}</p>
              <p><strong>기상 후 HR:</strong> {bagelLapsWorkoutDetail?.hrMornCount ?? '-'}</p>
              <p><strong>운동 후 STS:</strong> {bagelLapsWorkoutDetail?.stsAftCount ?? '-'}</p>
              <p><strong>운동 후 HR:</strong> {bagelLapsWorkoutDetail?.hrAftCount ?? '-'}</p>
              <p><strong>총 STS:</strong> {bagelLapsWorkoutDetail?.stsTotalCount}</p>
              <p><strong>총 HR:</strong> {bagelLapsWorkoutDetail?.hrTotalCount}</p>
              <p><strong>걸음 수:</strong> {bagelLapsWorkoutDetail?.walkSteps} 걸음</p>
            </PanelBarItem>
  
            <PanelBarItem title="식사 정보">
              <p><strong>아침:</strong> {bagelLapsWorkoutDetail?.breakfastTime}</p>
              <p><strong>점심:</strong> {bagelLapsWorkoutDetail?.lunchTime}</p>
              <p><strong>저녁:</strong> {bagelLapsWorkoutDetail?.dinnerTime}</p>
              <p><strong>간식 횟수:</strong> {bagelLapsWorkoutDetail?.snackCount}회</p>
            </PanelBarItem>
  
            <PanelBarItem title="체성분 분석">
              <p><strong>측정 시간:</strong> {bagelLapsWorkoutDetail?.bcMeasureTime}</p>
              <p><strong>체중:</strong> {bagelLapsWorkoutDetail?.bcWeight}kg</p>
              <p><strong>지방량:</strong> {bagelLapsWorkoutDetail?.bcFatMass}kg</p>
              <p><strong>근육량:</strong> {bagelLapsWorkoutDetail?.bcMuscleMass}kg</p>
              <p><strong>체지방률:</strong> {bagelLapsWorkoutDetail?.bcFatPct}%</p>
              <p><strong>BMI:</strong> {bagelLapsWorkoutDetail?.bmi}</p>
              <p><strong>복부지방률:</strong> {(bagelLapsWorkoutDetail?.bcAbdFatPct ?? 0) * 100}%</p>
              <p><strong>내장지방레벨:</strong> {bagelLapsWorkoutDetail?.bcVisceralFatLvl}</p>
            </PanelBarItem>
          </PanelBar>
        </CardBody>
      </Card>
      </div>
    );
  }

export default BagelLapsWorkoutDetailComponent;
